import { useState, useEffect } from "react";
import PropTypes from "prop-types";

// @mui material components
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

// RasPm Dashboard components
import MDButton from "components/MDButton";

// Form Component
import PositionForm from "../add";
import { RequestService } from "services/RequestService";

function UpdatePosition({ open, onClose, position, onSuccess }) {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
  });

  useEffect(() => {
    if (position) {
      setFormData({
        name: position.name || "",
      });
    }
  }, [position]);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      await RequestService.put(`Positions/${position.id}?name=${encodeURIComponent(formData.name)}`);
      onSuccess("تم تحديث المسمى الوظيفي بنجاح");
      onClose();
    } catch (error) {
      onSuccess(error.response?.data?.message || "حدث خطأ أثناء تحديث المسمى الوظيفي", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      dir="rtl"
    >
      <DialogTitle>تحديث المسمى الوظيفي</DialogTitle>
      <DialogContent>
        <PositionForm
          formData={formData}
          handleChange={setFormData}
        />
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'space-between', p: 2, gap: 1 }}>
        <MDButton 
          onClick={handleSubmit} 
          variant="gradient" 
          color="info" 
          size="small"
          disabled={loading}
        >
          حفظ التغييرات
        </MDButton>
        <MDButton 
          onClick={onClose} 
          variant="outlined" 
          color="error" 
          size="small"
          disabled={loading}
        >
          إلغاء
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}

UpdatePosition.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  position: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }),
  onSuccess: PropTypes.func.isRequired,
};

export default UpdatePosition;
